import React, {useEffect, useState} from 'react';
import EditableField from "../../common/EditableField/EditableField";
import {calculationCreditHistory, requestCreditHistory} from "../../../constants/constants";
import {kbStatus} from "../../../../../helpers/data-constants";
import {ActionButton} from "../../../../common";
import {useDispatch, useSelector} from "react-redux";
import {creditRegisterRequest, resetError} from "../../../../../redux/actions/autoLombardActions";
import {useParams} from "react-router-dom";
import BasicAlert from "../../../../utilites/Alert/Alert";

const CreditHistory = ({details: {credit_report_calculation, kb_message, client_info}}) => {
    const {error} = useSelector(({autolombard}) => autolombard.clients);
    const dispatch = useDispatch();
    const param = useParams();
    const [alertMessage, setAlertMessage] = useState(null);

    useEffect(() => {
        if (error) {
            setAlertMessage(error);
        }
    }, [error]);

    const renderSection = (title, data, valueResolver, button, isVisibleButton, isVisibleContent) => (
        <>
            <div className={isVisibleContent ? 'section-header-with-button' : 'section-header-non-data'}>
                {isVisibleContent && <h4>{title}</h4>}
                {isVisibleButton && button}
            </div>
            {isVisibleContent && Object.entries(data).map(([key, label]) => {
                const value = valueResolver(key);
                return (
                    <div key={key} className="details-item">
                        <div className="details-label value">{label}</div>
                        <EditableField
                            label={label}
                            value={value}
                        />
                    </div>
                );
            })}
        </>
    );

    const getRequestValue = (key) => {
        if (key === 'status') {
            const statusValue = kb_message?.[key] ?? '';
            return <span className={"label " + kbStatus[statusValue]?.label}>
                {kbStatus[statusValue]?.text}
            </span>;
        }
        return credit_report_calculation?.[key] ?? kb_message?.[key] ?? '';
    };

    const getCalculationValue = (key) => {
        if (key === 'status') {
            const statusValue = credit_report_calculation?.[key] ?? '';
            return <span className={"label " + kbStatus[statusValue]?.label}>
                {kbStatus[statusValue]?.text}
            </span>;
        }
        return credit_report_calculation?.[key] ?? '';
    };

    const getCreditRegister = () => {
        const data = {
            payload: {
                type: "REPORT",
                dealId: -1,
                clientId: client_info?.oneAppId,
            },
            requestId: param?.id
        }
        dispatch(creditRegisterRequest(data))
    }

    const handleCloseAlert = () => {
        setAlertMessage(null);
        dispatch(resetError())
    };

    return (
        <div className="details">
            <div className="details">
                {renderSection(
                    "Запрос в КР",
                    requestCreditHistory,
                    getRequestValue,
                    <ActionButton func={getCreditRegister} text='Отправить повторно'/>,
                    client_info && client_info?.oneAppId,
                    kb_message?.id
                )}
            </div>
            {credit_report_calculation && renderSection("Расчет кредитной истории", calculationCreditHistory, getCalculationValue)}
            <BasicAlert
                onClose={handleCloseAlert}
                message={alertMessage}
                isOpen={!!alertMessage}
                isError
            />
        </div>
    );
};

export default CreditHistory;